export var Status;
(function (Status) {
    Status["pending"] = "PENDING";
    Status["uploading"] = "UPLOADING";
    Status["uploadingFailed"] = "UPLOAD_FAILED";
    Status["uploaded"] = "UPLOADED";
    Status["allocating"] = "ALLOCATING";
    Status["allocated"] = "ALLOCATED";
    Status["allocateFailed"] = "ALLOCATE_FAILED";
    Status["streaming"] = "STREAMING";
    Status["streamingFailed"] = "STREAMING_FAILED";
    Status["closing"] = "CLOSING";
    Status["archiving"] = "ARCHIVING";
    Status["archivingFailed"] = "ARCHIVING_FAILED";
    Status["archived"] = "ARCHIVED";
    Status["archivedS3"] = "ARCHIVED_S3";
    Status["closed"] = "CLOSED";
    Status["expired"] = "EXPIRED";
    Status["retrieving"] = "RETRIEVING";
    Status["retrieved"] = "RETRIEVED";
    Status["notfound"] = "ERROR";
})(Status || (Status = {}));
export var Category;
(function (Category) {
    Category["flower"] = "FLOWER";
    Category["plantTree"] = "PLANT_TREE";
    Category["griefSupport"] = "GRIEF_SUPPORT";
    Category["communityEvent"] = "COMMUNITY_EVENT";
    Category["prePlanning"] = "PRE_PLANNING";
    Category["tributeBlanket"] = "TRIBUTE_BLANKET";
    Category["donation"] = "DONATION";
    Category["tribute"] = "TRIBUTE";
    Category["tributeMessage"] = "TRIBUTE_MESSAGE";
})(Category || (Category = {}));
export var Stage;
(function (Stage) {
    Stage["waitingRoom"] = "WAITING_ROOM";
    Stage["streaming"] = "STREAMING";
    Stage["onDemand"] = "ON_DEMAND";
    Stage["fullScreen"] = "FULL_SCREEN";
})(Stage || (Stage = {}));
export var VenueType;
(function (VenueType) {
    VenueType["funeralHome"] = "FUNERAL_HOME";
    VenueType["church"] = "CHURCH";
})(VenueType || (VenueType = {}));
/* export type TCommercialLink = {
  [key in Category]: string;
};
*/
export var Feature;
(function (Feature) {
    Feature["show_on_viewer_phone"] = "show_on_viewer_phone";
    Feature["new_viewer"] = "new_viewer";
    Feature["force_registration"] = "force_registration";
    Feature["plan_ahead"] = "plan_ahead";
    Feature["commercial_link"] = "commercial_link";
    Feature["custom_message"] = "custom_message";
    Feature["donation_widget"] = "donation_widget";
})(Feature || (Feature = {}));
export var FieldMandatory;
(function (FieldMandatory) {
    FieldMandatory["fullname_mandatory"] = "fullname_mandatory";
    FieldMandatory["email_mandatory"] = "email_mandatory";
    FieldMandatory["mobile_mandatory"] = "mobile_mandatory";
    FieldMandatory["relationship_mandatory"] = "relationship_mandatory";
    FieldMandatory["postcode_mandatory"] = "postcode_mandatory";
})(FieldMandatory || (FieldMandatory = {}));
export var FieldHidden;
(function (FieldHidden) {
    FieldHidden["mobile_hidden"] = "mobile_hidden";
    FieldHidden["relationship_hidden"] = "relationship_hidden";
    FieldHidden["postcode_hidden"] = "postcode_hidden";
})(FieldHidden || (FieldHidden = {}));
export const TributeActionLabels = {
    sendFlowers: 'Send Flowers',
    plantATree: 'Plant a Tree',
    getGriefSupport: 'Get Grief Support',
    communityEvent: 'Community Events',
    prePlanning: 'Pre-plan a Funeral',
    tributeBlanket: 'Buy Tribute Blanket',
    donation: 'Make a Donation',
    tributeMessage: 'Send a Message',
};
export const TributeCategory = {
    flower: 'FLOWER',
    plantTree: 'PLANT_TREE',
    griefSupport: 'GRIEF_SUPPORT',
    communityEvent: 'COMMUNITY_EVENT',
    prePlanning: 'PRE_PLANNING',
    tributeBlanket: 'TRIBUTE_BLANKET',
    donation: 'DONATION',
    tribute: 'TRIBUTE',
};
export var PageType;
(function (PageType) {
    PageType["WAITING_ROOM"] = "WAITING-ROOM";
    PageType["STREAMING"] = "STREAMING";
    PageType["ON_DEMAND"] = "ON-DEMAND";
    PageType["FULL_SCREEN"] = "FULL-SCREEN";
})(PageType || (PageType = {}));
